package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_02_23_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-02-23")
@Composable
public fun Log_2024_02_23(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The Compound Eye",
        ogTitle = "The Compound Eye",
        date = LocalDate(2_024, 2, 23),
        ogDescription = "In Dunstone, the party tracks down Dolly Mott to retrieve a violet gem known as the 'compound eye'.",
        ogImage = "ai/2024-02-23.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-45", dateString = "Newgrowth 45")
        Log_2024_02_23_Day_1()
    }
}
